import React from 'react'

import ChevronLeftSharpIcon from '@mui/icons-material/ChevronLeftSharp'
import ChevronRightSharpIcon from '@mui/icons-material/ChevronRightSharp'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import {makeStyles} from 'tss-react/mui'

import {useRTL} from '@progyny/hooks/useRTL'

export type ItemProps = {
  title: string
  caption: string
  onClick: () => void
  withBudget?: boolean
}

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  icon: {
    color: theme.palette.other.brandColors.darkGrey,
  },
  ListItemIconRoot: {
    minWidth: 'initial',
    marginInlineEnd: theme.spacing(2),
  },
  item: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    textIndent: 0,
  },
  gutters: {
    paddingInlineStart: 0,
  },
}))

const MenuItem = ({title, caption, onClick}: ItemProps): React.ReactNode => {
  const {classes} = useStyles()
  const {isRTL} = useRTL()

  return (
    <ListItem className={classes.item} classes={{gutters: classes.gutters}}>
      <ListItemButton onClick={onClick}>
        <ListItemText
          primary={
            <Typography className={classes.title} variant='h6'>
              {title}
            </Typography>
          }
          secondary={
            <Typography variant={'body2'} fontSize={16}>
              {caption}
            </Typography>
          }
        />
      </ListItemButton>
      <ListItemSecondaryAction>
        {isRTL ? (
          <ChevronLeftSharpIcon className={classes.icon} />
        ) : (
          <ChevronRightSharpIcon className={classes.icon} />
        )}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default MenuItem
